import { render } from "./BookedTrainingView.vue?vue&type=template&id=2af905c7"
import script from "./BookedTrainingView.vue?vue&type=script&lang=js"
export * from "./BookedTrainingView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__